import { render } from "./NotificationReminderActivity.vue?vue&type=template&id=fdbb9fba&scoped=true"
import script from "./NotificationReminderActivity.vue?vue&type=script&lang=js"
export * from "./NotificationReminderActivity.vue?vue&type=script&lang=js"

import "./NotificationReminderActivity.vue?vue&type=style&index=0&id=fdbb9fba&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdbb9fba"]])

export default __exports__